import AuroraB1 from './Aurora B.webp'
import AuroraB2 from './Aurora B.webp'


const AuroraBimages =[
AuroraB1,AuroraB2
]

export default AuroraBimages;